import React from 'react'
import { keyboardButtons } from '../constants/index'

const Keyboard = ({ dispatch, state }) => {
  const handleNumberClick = (e, value, backspace = false) => {
    e.preventDefault()
    if (backspace) {
      dispatch({ type: 'backspace' })
      return
    }
    if (value === ',') {
      dispatch({ type: state.activeInputName, payload: '.' })
      return
    }
    dispatch({ type: state.activeInputName, payload: value })
  }

  return (
    <div className='calculator-ma__keyboard'>
      {keyboardButtons.map(({ value, backspace }, index) => {
        return <button key={index} onClick={(e) => handleNumberClick(e, value, backspace)} className={`calculator-ma__operator-btn ${backspace ? 'calculator-ma__operator-btn--backspace' : ''}`}>{value}</button>
      })}
    </div>
  )
}

export default Keyboard
